import React from 'react'
import BResourcePage from '../../../components/resources/BResourcePage';

export default function CoworkersPage() {
    return (
        <BResourcePage
          title={"Mitarbeiter"}
          url={"/coworkers"}
        />
      );
}
